import {forEach} from "lodash"

export default {
    el: '#banner-slider-wrapper',
    name: 'StartPageVideo',
    data: function () {
        return {
            videoEl: null,
            videoSources: [],
            styles: {
                //height:
            },

        }
    },
    mounted: function () {
        var MobileDetect = require('mobile-detect')
        var md = new MobileDetect(window.navigator.userAgent)

        let value1 = '6.8'
        let value2 = '2.4'
        let value3 = '7.4'

        let minFontSize1 = '13px'
        let minFontSize2 = '28px'

        let maxFontSize1 = '200px'
        let maxFontSize2 = '200px'

        //if tablet
        if (md.tablet() != null) {
            value1 = '4.9'
            value2 = '1.8'
            value3 = '5'
            maxFontSize1 = '22px'
            maxFontSize2 = '68px'
        }

        jQuery('.text-top').fitText(value1, {
            minFontSize: minFontSize1,
            maxFontSize: maxFontSize1,
            after: function () {
                $(this).addClass('fade-in')
            }
        })
        jQuery('.text-headline').fitText(value2, {
            minFontSize: minFontSize2,
            maxFontSize: maxFontSize2,
            after: function () {
                $(this).addClass('fade-in')
            }
        })
        jQuery(".text-sub").fitText(value3, {
            minFontSize: minFontSize1,
            maxFontSize: maxFontSize1,
            after: function () {
                $(this).addClass('fade-in')
            }
        })

        this.initHeroSlider()

        this.$el.style.visibility = 'visible'

        //Listeners
        //this.setEventListeners();

        /*
        $('#ec-turntable').turntable({
            axis: 'scroll',
            scrollStart: 'top',
        })
        */

    },
    methods: {
        initHeroSlider() {
            this.$nextTick(() => {
                $('#banner-slider').slick({
                    slidesToShow: 1,
                    infinite: true,
                    slidesToScroll: 1,
                    waitForAnimate: false,
                    swipeToSlide: true,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    speed: 500,
                    accessibility: true,
                    prevArrow: '<button class="prevArrow" type="button"><img src="images/arrowLeft.svg" /></button>',
                    nextArrow: '<button class="nextArrow" type="button"><img src="images/arrowRight.svg" /></button>',
                    responsive: [
                        {
                            breakpoint: 563,
                            settings: 'unslick'
                        }
                    ]
                })

                $(window).on('load resize', function () {
                    var numberOfSlides = $('#banner-slider').slick('getSlick').$slides.length

                    if ($(window).width() >= 563 && numberOfSlides === 1) {
                        const bannerSlider = $('#banner-slider')

                        forEach(Laravel.SliderImages, (image) => {
                            bannerSlider.slick('slickAdd', '<div><img src="'+image+'" /></div>')
                        })
                    } else if ($(window).width() >= 563 && numberOfSlides > 1) {
                        $('#banner-slider').slick('init').slick('setPosition')
                    } else if ($(window).width() < 563) {
                        $('#banner-slider').slick('unslick')
                    }
                })
            })
        },

    },
}